import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { popUpMenuChange,
        toggleSwitch,
        selectedCardsGroupsChange,
        popUpMessageChange,
        closedCardsGroupsChange } from '../../actions/index'

import Icon from '@mdi/react';
import { mdiFileSign } from '@mdi/js';

import { _ } from '../../functions/translator';
import { ToggleActions } from '../../constants/constants';

class SignButton extends React.Component{
         
    handleClick = async () => {        
        this.props.closedCardsGroupsChange(this.props.closableCardsGroups)
        this.props.toggleSwitch(ToggleActions.SIGNATURE)
        this.props.popUpMenuChange({ show: false })
        this.props.selectedCardsGroupsChange([])
    }
    
    getCardsGroupsCount = () => {
        let text = ''
        if (this.props.closableCardsGroups.length > 0) {
            text += '(' + this.props.closableCardsGroups.length + ' '
            text += this.props.closableCardsGroups.length > 1 ? _('disponibles') + ')' : _('disponible') + ')'
        }
        return text
    }

    render(){   

        let totalClosable = this.getCardsGroupsCount()
        return (
            <div>
                <div className="popup-menu-button card-color" ref={ref => this.button = ref } onClick={ this.handleClick }>
                    <div className='d-inline-flex'>
                        <Icon path={ mdiFileSign } size='30px' color='white' style={{marginTop: 10, marginLeft: 15, marginRight: 10}}/>
                        <p>{ _('Firmar') }<span>{ totalClosable }</span></p>
                    </div>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        popUpMenu : state.popUpMenu,
        userRole  : state.userRole,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({
        popUpMenuChange : popUpMenuChange,
        toggleSwitch : toggleSwitch,
        selectedCardsGroupsChange : selectedCardsGroupsChange,
        popUpMessageChange : popUpMessageChange,
        closedCardsGroupsChange : closedCardsGroupsChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(SignButton)